import script from "./ScreenShotActivityBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenShotActivityBar.vue?vue&type=script&setup=true&lang=js"

import "./ScreenShotActivityBar.vue?vue&type=style&index=0&id=5a827df7&lang=css"

const __exports__ = script;

export default __exports__